import React, { useEffect, useRef} from 'react';
import {useState} from 'react'
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import "../../assets/css/modal.css";
import "./ResetPassword.css";
import PropTypes from "prop-types";
import "../../assets/css/component.css";
import { FiLock } from "react-icons/fi";
import Verification from "./Verification"
import ConfirmPassword from './ConfirmPassword';
import { turnOffButton, turnOnButton } from './buttonFunctions';
import Spinner from '../../common/Spinner';
import { load, doneLoading, createVerification } from "../../actions/userActions"
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";

const ResetPassword = (props) =>{
  const [resetPasswordData, setResetPasswordData] = useState({})
  const [canSubmit, setButtonState] = useState(false)
  const buttonElement = useRef(null)
  const [openVerification, setVerificationVisible] = useState(false)
  const [openConfirmation, setConfirmationVisible] = useState(false)
  const [passwordEmail,setEmail]=React.useState('');
  const [emailStatus,setEmailStatus]=React.useState('');
  const [forceHide, setForceHide] = useState(false);

  turnOnButton(buttonElement.current)

  useEffect(() => {
    if (props.show) setForceHide(false);
  }, [props.show]);

const handleSubmit = (e) => {
  e.preventDefault(); 
        
      // axios.post("/password/create", {"email": passwordEmail}).then((res)=>{
      //   props.doneLoading()
      //   setResetPasswordData({...resetPasswordData, "email": passwordEmail})
      //   setVerificationVisible(true)
      // }).catch((error)=>{
      //   props.doneLoading()
      //   console.log(error)
      // })
  if (props?.data?.email === passwordEmail) {
    props.createVerification(passwordEmail);

  } else {
    setEmailStatus(<div className="footer-warley-description text-danger">Email is not registered with this account!</div>)
  }
};

  const handleClose = () => {
    setResetPasswordData({})
    props.onHide()
  }

  useEffect(()=>{ //CHECK IF CREATE VERIFICATION CODE WAS A SUCCESS(user.verificationCode is not null)
    console.log(props.user.verificationCode)
  if (props.user.verificationCode?.data) {
      console.log("HEY")
      setResetPasswordData({...resetPasswordData, "email": passwordEmail})
      setVerificationVisible(true)
  }
  }, [props.user.verificationCode])

  useEffect(()=>{
    turnOffButton(buttonElement.current)

    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    if(emailRegex.test(passwordEmail)){
      turnOnButton(buttonElement.current)
    }
    

  }, [passwordEmail])

  function handleChange(event){
    setEmailStatus('');
    setEmail(event.target.value);
    event.preventDefault();
  }


  return(

    <>
      <Verification 
      show={openVerification} 
      verificationVisibility={setVerificationVisible} 
      confirmationVisibility={setConfirmationVisible}
      resetData={resetPasswordData}
      setResetData={setResetPasswordData}
      passwordEmail={passwordEmail}
      />
      <ConfirmPassword 
      show={openConfirmation} 
      confirmationVisibility={setConfirmationVisible}
      resetData={resetPasswordData}
      setResetData={setResetPasswordData}
      hideResetPassword={() => setForceHide(true)}
      close={props.close}
      showSuccess={props.showSuccess}
      hideSuccess={props.hideSuccess}
      goToLogin={props.goToLogin}
      />
      <Modal
        show={props.show && !forceHide}
        onHide={handleClose}
        dialogClassName="rp-dialog"
        contentClassName="rp-content"
        centered
        aria-labelledby="reset-password-modal"
      >
        <form onSubmit={handleSubmit}>

          {/* ---- Close ---- */}
          <ModalCloseButton onClick={props.onHide} />

          <Modal.Body className="rp-body">

            {/* ---- Icon ring ---- */}
            <div className="rp-icon-ring">
              <FiLock size={30} color="#e54046" />
            </div>

            <div className="rp-title">Reset your password</div>
            <div className="rp-subtitle">
              A verification code will be sent to the registered email
            </div>

            <label className="rp-label">Enter your email</label>
            <input
              type="email"
              className="rp-input"
              required
              autoComplete="off"
              placeholder="you@example.com"
              onChange={handleChange}
            />
            <div className="rp-status">{emailStatus}</div>

          </Modal.Body>

          <Modal.Footer className="rp-footer">
            <button
              type="submit"
              className="rp-submit-btn"
              ref={buttonElement}
              style={{ opacity: 0.5 }}
              disabled
            >
              Get verification code
            </button>
            <div className="rp-powered">Powered by Warely</div>
          </Modal.Footer>

        </form>
      </Modal>
    </>
    )
}

ResetPassword.propTypes = {
  closeModal: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default withTranslation()(
  connect(mapStateToProps, {
    load, doneLoading, createVerification
  })(ResetPassword)
);